import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePatientCDMStatus = (patientId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["patientCDMStatus", patientId],
    queryFn: async () => {
      if (!patientId) return null;
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/cdm/patients/${patientId}/status`
      );
      return response.data;
    },
    enabled: !!patientId && !!tenantVal,
  });
};
